import React from "react"
import { useTranslation } from "react-i18next"

import type {
  MessageRow,
  MessageSourceKey,
  MessageStatus
} from "../types/messages.types.ts"
import { StatusDot, type Tone } from "./ui.tsx"

const TONES: Record<MessageStatus, Tone> = {
  queued: "neutral",
  sending: "processing",
  sent: "info",
  delivered: "success",
  bounced: "danger",
  complained: "danger",
  failed: "danger",
  skipped: "warning"
}

export const messageTone = (status: string): Tone =>
  TONES[status as MessageStatus] ?? "neutral"

export const MessageStatusDot = ({
  status,
  pill = false
}: {
  status: string
  pill?: boolean
}) => {
  const { t } = useTranslation()
  return (
    <StatusDot
      tone={messageTone(status)}
      pill={pill}
      label={t(`communication.messages.status.${status}`, {
        defaultValue: status
      })}
    />
  )
}

const CAMPAIGN_FEATURES = new Set(["campaign", "lead_email_campaign"])
const MANUAL_FEATURES = new Set(["compose", "reply"])

/** The server's `source` when it sends one; an older backend's rows are read from `source_feature`. */
export const sourceOf = (
  row: Pick<MessageRow, "source" | "source_feature">
): MessageSourceKey => {
  if (row.source) return row.source
  const feature = row.source_feature ?? ""
  if (CAMPAIGN_FEATURES.has(feature)) return "campaign"
  if (feature === "automation") return "automation"
  if (MANUAL_FEATURES.has(feature)) return "manual"
  return "system"
}
